































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreateRecruit from "./create-recruit.vue";
import EditRecruit from "./edit-recruit.vue";
import Ajax from "../../lib/ajax";

class PageRecruitRequest extends PageRequest {
    postName: string;
    jobAddress: string;
}

@Component({
    components: { CreateRecruit, EditRecruit }
})
export default class Recruits extends AbpBase {
    edit() {
        this.editModalShow = true;
    }
    //filters
    pagerequest: PageRecruitRequest = new PageRecruitRequest();

    createModalShow: boolean = false;
    editModalShow: boolean = false;

    regions = [];

    get list() {
        return this.$store.state.recruit.list;
    }
    get loading() {
        return this.$store.state.recruit.loading;
    }
    create() {
        this.createModalShow = true;
    }

    pageChange(page: number) {
        this.$store.commit("recruit/setCurrentPage", page);
        this.getpage();
    }
    pagesizeChange(pagesize: number) {
        this.$store.commit("recruit/setPageSize", pagesize);
        this.getpage();
    }
    search() {
        this.$store.commit("recruit/setCurrentPage", 1);
        this.getpage();
    }
    async getpage() {
        this.pagerequest.maxResultCount = this.pageSize;
        this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
        //filters

        await this.$store.dispatch({
            type: "recruit/getMyRecruits",
            data: this.pagerequest
        });
    }
    get pageSize() {
        return this.$store.state.recruit.pageSize;
    }
    get totalCount() {
        return this.$store.state.recruit.totalCount;
    }
    get currentPage() {
        return this.$store.state.recruit.currentPage;
    }
    columns = [
        {
            title: this.L("PostName"),
            key: "postName",
            tooltip: true
        },
        {
            title: this.L("Salary"),
            key: "salary",
            width: 150
        },
        {
            title: this.L("LinkMan"),
            key: "linkMan",
            width:150
        },
        {
            title: this.L("TelPhone"),
            key: "telPhone",
            width: 120
        },
        {
            title: this.L("CreationTime"),
            key: "creationTime",
            width: 120,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    new Date(params.row.creationTime).toLocaleDateString()
                );
            }
        },
        {
            title: this.L("Actions"),
            key: "Actions",
            width: 80,
            align: "center",
            render: (h: any, params: any) => {
                return h(
                    "Dropdown",
                    {
                        style: {
                            marginLeft: "5px"
                        },
                        props: {
                            placement: "bottom-start",
                            transfer: true
                        },
                        on: {
                            "on-click": async name => {
                                switch (name) {
                                    case "edit":
                                        this.$store.commit(
                                            "recruit/edit",
                                            params.row
                                        );
                                        this.edit();
                                        break;
                                    case "delete":
                                        this.$Modal.confirm({
                                            title: this.L("Tips"),
                                            content: this.L(
                                                "RecruitDeleteWarningMessage"
                                            ),
                                            okText: this.L("Yes"),
                                            cancelText: this.L("No"),
                                            onOk: async () => {
                                                await this.$store.dispatch({
                                                    type: "recruit/delete",
                                                    data: params.row
                                                });
                                                await this.getpage();
                                            }
                                        });
                                        break;
                                    default:
                                        break;
                                }
                            }
                        }
                    },
                    [
                        h(
                            "a",
                            {
                                attrs: {
                                    href: "javascript:void(0)"
                                }
                            },
                            [
                                this.L("Actions"),
                                h("Icon", {
                                    props: {
                                        type: "ios-arrow-down"
                                    }
                                })
                            ]
                        ),
                        h(
                            "DropdownMenu",
                            {
                                slot: "list"
                            },
                            [
                                h(
                                    "DropdownItem",
                                    {
                                        props: {
                                            name: "edit"
                                        }
                                    },
                                    this.L("Edit")
                                ),
                                h(
                                    "DropdownItem",
                                    {
                                        props: {
                                            name: "delete"
                                        }
                                    },
                                    this.L("Delete")
                                )
                            ]
                        )
                    ]
                );
            }
        }
    ];
    async created() {
        this.getpage();
    }
}
